/**
 * 可重复添加tag组件
 * @description 可重复添加tag组件
 * @author yly
 * @date 2023-03-27
 */
import React from 'react';
import { connect } from 'dva';
import { ConsoleSqlOutlined, PlusCircleOutlined } from '@ant-design/icons';
import { Tag, Modal, List, Alert } from 'antd';
import './index.less'
import { framework_tool } from '@/tool'
const { WizContainer, modelUtils } = framework_tool;
class TagSelect extends WizContainer {

  constructor(props) {
    super(props);
    this.state = {
      modalBol: false,
      tagList: [],
      innerTagList:[],
      tagIndex: 0,
      keyTime: new Date().getTime(),
      bizType: 15,
      userColumns: [],
      schemaColumns: [],
      columnsList: []
    }
  }
  _componentDidMount() {
    let { bizType } = this.state
    this.doActions([
      {
        path: 'schemaColumns/userInfo',
        payload: {
          key: 'getUserColumnsInfo',
          apiParams: {}
        }
      },
      {
        path: 'schemaColumns/columnsInfo',
        payload: {
          key: 'getSchemaColumnsInfo',
          apiParams: {
            bizType: bizType
          }
        }
      }
    ]);
  }

  propsAndStateOnChange = {
    userColumnsInfo: this._getUserColumnsInfoOver.bind(this),
    schemaColumnsInfo: this._getSchemaColumnsInfoOver.bind(this),
    initialValue: this._getInitialValue.bind(this)
  }
  _getInitialValue(nextProps, nextState) {
    let { initialValue } = nextProps
    let { userColumns, schemaColumns } = nextState
    if (initialValue && initialValue.length > 0) {
      let arr = []
      let schemaDict = this.formatList(userColumns, schemaColumns)
      initialValue.forEach((item, index) => {
        if (schemaDict.find(x => x.value == item)) {
          let val = schemaDict.find(x => x.value == item)
          arr.push({ value: val.value, label: val.label, keyIndex: index })
        }
      })
      nextState.tagList = arr
    }
  }
  _getUserColumnsInfoOver(nextProps, nextState) {
    let { userColumnsInfo } = nextProps
    if (userColumnsInfo.code === 1) {
      if (userColumnsInfo && userColumnsInfo.success) {
        nextState.userColumns = userColumnsInfo.data
      }
    } else {
      wizNotice.error('获取数据失败：' + nextProps.userColumnsInfo.msg);
    }
    return true;
  }
  _getSchemaColumnsInfoOver(nextProps, nextState) {
    let { schemaColumnsInfo } = nextProps
    if (schemaColumnsInfo.code === 1) {
      if (schemaColumnsInfo && schemaColumnsInfo.success) {
        nextState.schemaColumns = schemaColumnsInfo.data
      }
    } else {
      wizNotice.error('获取数据失败：' + nextProps.schemaColumnsInfo.msg);
    }
    return true;
  }

  addTags = (item) => {
    let newIndex = this.state.tagIndex
    newIndex = newIndex + 1;
    let arr = [...this.state.innerTagList]

    arr.push({ value: item.value, label: item.label, keyIndex: newIndex })
    this.setState({ tagIndex: newIndex })
    this.setState({ innerTagList: arr })
  }
  formatList = (aList, bList) => {
    let schemaDict = []
    if (aList && Array.isArray(aList) && aList.length) {
      aList.forEach(user => {
        schemaDict.push({ value: user.columnName, label: '用户：' + user.columnComment })
      })
    }
    if (bList && Array.isArray(bList) && bList.length) {
      bList.forEach(obj => {
        if (obj.columnName && obj.columnName.indexOf('apply_') == 0) {
          schemaDict.push({value: obj.columnName, label: '报名：' + obj.columnComment})
        }
        if (obj.columnName && obj.columnName.indexOf('class_') == 0) {
          schemaDict.push({value: obj.columnName, label: '班级：' + obj.columnComment})
        }
      })
    }
    return schemaDict
  }
  render() {
    let { initialValue, submitTags } = this.props;
    const openModal = () => {
      this.setState({ modalBol: true })
      this.setState({ innerTagList: [...this.state.tagList] })
    }

    const closeTag = (e, item) => {
      let arr = [...this.state.tagList]
      arr = arr.filter(x => x.keyIndex != item.keyIndex)
      changeValue(arr)
      this.setState({ tagList: arr })
      e.stopPropagation()
    }
    const innerCloseTag = (e, item) => {
      let arr = [...this.state.innerTagList]
      arr = arr.filter(x => x.keyIndex != item.keyIndex)
      this.setState({ innerTagList: arr })
    }
    const okTags = () => {
      let arr = [...this.state.innerTagList]
      this.setState({ tagList: arr })
      changeValue(arr)
      this.setState({ modalBol: false })
    }

    const changeValue = (tagList) => {
      let submitArr = []
      tagList.forEach(item => [
        submitArr.push(item.value)
      ])
      submitTags(submitArr)

    }
    const cancelTags = () => {
      this.setState({ innerTagList: [...this.state.tagList] })
      this.setState({ modalBol: false })
    }
    return (
      <>
        <div className='tag-select' style={{ background: 'white' }} onClick={() => openModal()} key={this.state.keyTime}>
          {this.state.tagList.map((item, index) => {
            return (<Tag closable onClose={(e) => closeTag(e, item)} key={item.keyIndex}>{item.label}</Tag>)
          })}
        </div>
        <Modal className='tag-modal' title="内容信息参数" visible={this.state.modalBol} onOk={() => okTags()} onCancel={() => cancelTags()}>

          <div className='scroll-view'>
            <List
              size="small"
              bordered
              dataSource={this.formatList(this.state.userColumns, this.state.schemaColumns)}
              renderItem={(item) => <List.Item className='list-item' onClick={() => this.addTags(item)}
                key={item.value}><PlusCircleOutlined /><span className='name-right'>{item.label}</span></List.Item>}
            />
          </div>
          <div>
            {this.state.innerTagList && this.state.innerTagList.length > 0 && this.state.innerTagList.map((item, index) => {
              return (<Tag closable onClose={(e) => innerCloseTag(e, item)} key={item.keyIndex}>{item.label}</Tag>)
            })}
          </div>
        </Modal>
      </>
    )
  }

}
const mapStateToProps = (state, ownProps) => {
  const { inviteLetter, schemaColumns } = state;
  const inviteLetterInfo = modelUtils.getModelEntity(inviteLetter, "inviteLetterInfo");
  const addInviteLetter = modelUtils.getModelEntity(inviteLetter, "addInviteLetter");
  const userColumnsInfo = modelUtils.getModelEntity(schemaColumns, "getUserColumnsInfo");
  const schemaColumnsInfo = modelUtils.getModelEntity(schemaColumns, "getSchemaColumnsInfo");
  const load = modelUtils.getLoadingState(state, ['inviteLetter', 'schemaColumns']);
  return {
    inviteLetterInfo: inviteLetterInfo,
    addInviteLetter: addInviteLetter,
    userColumnsInfo: userColumnsInfo,
    schemaColumnsInfo: schemaColumnsInfo,
    ...load
  }
};

export default connect(mapStateToProps)(TagSelect);
